import React, { useEffect, useRef, useState } from 'react';
import { Dialog, DialogFooter, DialogType, FontIcon, FontSizes, getTheme, MessageBarType } from '@fluentui/react';
import { BwjButton, BwjButtonType } from '../bwj-button';
import { IShowToastArgs } from '../../services/toast';
import { BwjEventArgs } from '../../entities/bwj-event';
import { getBwjAnnouncementBannerColorScheme } from '../bwj-announcement/color';

interface IPrivateToastDialogProps {
  launchDialog: BwjEventArgs<IBwjShowToastDialogArgs> | undefined;
  closeDialogButtonText: string;
}

export interface IBwjShowToastDialogArgs {
  content: IShowToastArgs;
  icon: string;
}

export const PRIVATE_TOAST_DIALOG: React.FunctionComponent<IPrivateToastDialogProps> = (props) => {
  const { launchDialog } = props;
  const [showDialog, setShowDialog] = useState(false);
  const theme = getTheme();
  const dialogProps = useRef<IBwjShowToastDialogArgs | undefined>(undefined);
  const color = getBwjAnnouncementBannerColorScheme(dialogProps.current?.content.type ?? MessageBarType.info);

  // on show dialog invoked
  useEffect(() => {
    if(launchDialog === undefined || launchDialog.inaccessible()) { return; }
    const args = launchDialog.getArgs();
    dialogProps.current = args;
    setShowDialog(true);
  }, [launchDialog]);

  const onDismiss = () => setShowDialog(false);

  const dp = dialogProps.current;
  return (
    <>
      {!!dp &&
      <Dialog
        hidden={showDialog === false}
        onDismiss={onDismiss}
        dialogContentProps={{ type: DialogType.normal }}
        modalProps={{
          isBlocking: false,
          styles: {
            main: {
              width: '100%',
              maxWidth: 500,
            },
            scrollableContent: {
              fontSize: theme.fonts.medium.fontSize,
              '& > div': {
                borderTop: `0.5em solid ${color.main}`,
                backgroundColor: color.background,
              },
              '& .ms-Dialog-header': {
                display: 'none',
              },
              '& .ms-Dialog-inner': {
                padding: '1.5em',
              },
            },
          }
        }}
      >
        {!!dp.icon &&
        <FontIcon
          iconName={dp.icon}
          style={{
            fontSize: FontSizes.superLarge,
            color: color.main,
          }}
        />}
        <p>
          {dp.content.message}
        </p>
        <DialogFooter
        styles={{
          actions: {
            fontSize: 16,
            marginTop: '2em',
          }
        }}
        >
          <BwjButton
            buttonStyle={BwjButtonType.DefaultStandard}
            text={props.closeDialogButtonText}
            onClick={onDismiss}
          />
        </DialogFooter>
      </Dialog>}
    </>
  );
};
